import { PresetterMode, PRESETTER_MODES } from '../utils/constants';

interface PresetterSelectorProps {
  mode: PresetterMode;
  onModeChange: (mode: PresetterMode) => void;
}

export function PresetterSelector({ mode, onModeChange }: PresetterSelectorProps) {
  const modes = Object.entries(PRESETTER_MODES) as [PresetterMode, typeof PRESETTER_MODES[PresetterMode]][];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4">
      <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3">
        Presetter Mode
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {modes.map(([key, config]) => (
          <label
            key={key}
            className={`
              flex flex-col items-center p-3 rounded-lg cursor-pointer border-2 transition-all
              ${mode === key
                ? 'border-industrial-500 bg-industrial-50 dark:bg-industrial-900/30'
                : 'border-gray-200 dark:border-gray-600 hover:border-industrial-300 dark:hover:border-industrial-700'
              }
            `}
          >
            <input
              type="radio"
              name="presetter-mode"
              value={key}
              checked={mode === key}
              onChange={() => onModeChange(key)}
              className="sr-only"
            />
            <span className="font-mono font-bold text-lg text-gray-800 dark:text-gray-200">
              {config.label}
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              {config.dParams[0]}-{config.dParams[3]}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
